const INFO_PAX_MONETARY = (state, data) => {
  state.InfoPaxMonetary = data
}
export default {
  INFO_PAX_MONETARY
}
